import { Children, isValidElement } from 'react'
import type { ReactNode } from 'react'

const renderedButtons = (children: ReactNode) => Children.map(children, child => ({ child })) ?? []

export const pulsePillSelection = (
  isPulse: boolean,
  selected: number | number[] | undefined,
  mode: string | undefined,
  children: ReactNode,
) => {
  const enabled = isPulse && selected !== undefined && mode !== 'checkbox'
  const isMultiple = Array.isArray(selected) && selected.length > 1
  const childIndex = Array.isArray(selected) ? selected[0] : selected
  const nodes = renderedButtons(children)
  const selectedChild = childIndex === undefined ? undefined : nodes[childIndex]?.child

  if (!enabled || isMultiple || !isValidElement<{ disabled?: boolean }>(selectedChild)) {
    return { enabled, selectedIndex: undefined, selectedDisabled: false }
  }

  return {
    enabled,
    selectedIndex: nodes.slice(0, childIndex).filter(({ child }) => isValidElement(child)).length,
    selectedDisabled: Boolean(selectedChild.props.disabled),
  }
}
